import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';
import { usePermissionStore } from '@/store/admin/permission';

// 前台元件
import Overview from '../pages/Driver/overview/index.vue';
import Transaction from "@/pages/Driver/payments/transactions/index.vue";
import Settlements from "@/pages/Driver/payments/settlements/index.vue";
import Reports from "@/pages/Driver/payments/reports/index.vue";
import WithDrawFunds from '@/pages/Driver/payments/withdrawFunds/index.vue'
import Profile from "@/pages/Driver/profile/index.vue";
import Help from '@/pages/Driver/help/index.vue';
import CardPayment from '@/pages/Driver/card/index.vue';

// 後台元件
import CashPayments from '../pages/cashPayments/index.vue';
import Dashboard from "@/pages/dashboard/index.vue";
import Transactions from "@/pages/transactions/index.vue";
import DriverProfile from "@/pages/driverProfile/index.vue";
import Subgroups from "@/pages/subgroups/index.vue";
import Terminal from '@/pages/terminal/index.vue';
import TerminalPerformance from '@/pages/terminalPerformance/index.vue';
import FeesCharges from '@/pages/feesCharges/index.vue';
import Refunds from '@/pages/refunds/index.vue';
import StaffMembers from '@/pages/staffMembers/index.vue';
import Fleet from '@/pages/fleet/index.vue';
import Role from '@/pages/role/index.vue';
import Settings from '@/pages/settings/index.vue';
import CardApplication from '@/pages/card/cardApplication.vue';
import CardManagement from '@/pages/card/cardManagement.vue';
import CardPerformance from '@/pages/card/cardPerformance.vue';
// 一頁式 Reciept search
import ReceiptSearch from '@/pages/receiptSearch/index.vue';

// 登錄畫面
import login from '@/pages/login/index.vue';
import DriverLogin from "@/pages/login/driverLogin.vue";
import Unauthorized from '@/pages/unauthorized/index.vue';
import Home from '@/pages/home/index.vue';

import axios from 'axios';

async function fetchDriverInfo(token) {
  const response = await axios.get(`${process.env.VUE_APP_PUBLIC_PATH}/api/driver/driver/info`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const userInfo = response.data.result;
  // 更新 localStorage
  localStorage.setItem('Driver', JSON.stringify({
    role: 'user',
    ...userInfo
  }));
}

const routes = [
  // 前台路由
  {
    path: '/',
    component: Body,
    children: [
      {
        path: '',
        name: 'Overview',
        component: Overview,
        meta: {
          title: 'Taxi1-Overview',
          requiresAuth: true,
          role: 'user', // 前台用户
        }
      },
      {
        path: '/transaction',
        name: 'Transaction',
        component: Transaction,
        meta: {
          title: 'Taxi1-Transaction',
          requiresAuth: true,
          role: 'user',
        }
      },
      {
        path: '/settlements',
        name: 'Settlements',
        component: Settlements,
        meta: {
          title: 'Taxi1-Settlements',
          requiresAuth: true,
          role: 'user',
        }
      },
      {
        path: '/reports',
        name: 'Reports',
        component: Reports,
        meta: {
          title: 'Taxi1-Reports',
          requiresAuth: true,
          role: 'user',
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {
          title: 'Taxi1-Profile',
          requiresAuth: true,
          role: 'user',
        }
      },
      {
        path: '/withdraw-funds',
        name: 'WithDrawFunds',
        component: WithDrawFunds,
        meta: {
          title: 'Taxi1-WithDrawFunds',
          requiresAuth: true,
          role: 'user',
        }
      },
      { 
        path: '/card-payment',
        name: 'CardPayment',
        component: CardPayment,
        meta: {
          title: 'Taxi1-Card',
          requiresAuth: true,
          role: 'user',
        }
      },
      {
        path: '/help',
        name: 'Help',
        component: Help,
        meta: {
          title: 'Taxi1-Help',
          requiresAuth: true,
          role: 'user',
        }
      }
    ]
  },

  // 後台路由
  {
    path: '/admin',
    component: Body,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
        meta: {
          title: 'Taxi1-Home',
          requiresAuth: true,
          role: 'admin',
        }
      },
      {
        path: 'cash-payments',
        name: 'CashPayments',
        component: CashPayments,
        meta: {
          title: 'Taxi1-CashPayments',
          requiresAuth: true,
          role: 'admin',
        }
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          title: 'Taxi1-Dashboard',
          requiresAuth: true,
          role: 'admin',
          permission: 'Dashboard'
        }
      },
      {
        path: 'transactions',
        name: 'Transactions',
        component: Transactions,
        meta: {
          title: 'Taxi1-Transactions',
          requiresAuth: true,
          role: 'admin',
          permission: 'Transactions'
        }
      },
      {
        path: 'driver-profile',
        name: 'DriverProfile',
        component: DriverProfile,
        meta: {
          title: 'Taxi1-DriverProfile',
          requiresAuth: true,
          role: 'admin',
          permission: 'Driver profile'
        }
      },
      {
        path: 'subgroups',
        name: 'Subgroups',
        component: Subgroups,
        meta: {
          title: 'Taxi1-Subgroups',
          requiresAuth: true,
          role: 'admin',
          permission: 'Subgroups'
        }
      },
      {
        path: 'terminal',
        name: 'Terminal',
        component: Terminal,
        meta: {
          title: 'Taxi1-Terminal',
          requiresAuth: true,
          role: 'admin',
          permission: 'Terminal'
        }
      },
      {
        path: 'terminal-performance',
        name: 'TerminalPerformance',
        component: TerminalPerformance,
        meta: {
          title: 'Taxi1-TerminalPerformance',
          requiresAuth: true,
          role: 'admin',
          permission: 'Terminal performance'
        }
      },
      {
        path: 'fees-charges',
        name: 'FeesCharges',
        component: FeesCharges,
        meta: {
          title: 'Taxi1-FeesCharges',
          requiresAuth: true,
          role: 'admin',
          permission: 'Fees & charges'
        }
      },
      {
        path: 'card-application',
        name: 'CardApplication',
        component: CardApplication,
        meta: {
          title: 'Taxi1-CardApplication',
          requiresAuth: true,
          role: 'admin',
        }
      },
      {
        path: 'card-management',
        name: 'CardManagement',
        component: CardManagement,
        meta: {
          title: 'Taxi1-CardManagement',
          requiresAuth: true,
          role: 'admin',
        }
      },
      {
        path: 'card-performance',
        name: 'CardPerformance',
        component: CardPerformance,
        meta: {
          title: 'Taxi1-CardPerformance',
          requiresAuth: true,
          role: 'admin',
        }
      },
      {
        path: 'refunds',
        name: 'Refunds',
        component: Refunds,
        meta: {
          title: 'Taxi1-Refunds',
          requiresAuth: true,
          role: 'admin',
          permission: 'Refunds'
        }
      },
      {
        path: 'staff-members',
        name: 'StaffMembers',
        component: StaffMembers,
        meta: {
          title: 'Taxi1-StaffMembers',
          requiresAuth: true,
          role: 'admin',
          permission: 'Staff members'
        }
      },
      {
        path: 'fleet',
        name: 'fleet',
        component: Fleet,
        meta: {
          title: 'Taxi1-Fleet',
          requiresAuth: true,
          role: 'admin',
          permission: 'Fleet'
        }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        meta: {
          title: 'Taxi1-Settings',
          requiresAuth: true,
          role: 'admin',
          permission: 'Settings'
        }
      },
      {
        path: 'role',
        name: 'Role',
        component: Role,
        meta: {
          title: 'Taxi1-Role',
          requiresAuth: true,
          role: 'admin',
        }
      }
    ]
  },
  {
    path: '/receipt-search',
    name: 'ReceiptSearch',
    component: ReceiptSearch,
    meta: {
      title: 'Taxi1-ReceiptSearch',
    }
  },
  // 管理端登录页面
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: login,
    meta: {
      title: 'Login | Admin | Taxi1',
    }
  },
  
  // 用户端登录页面
  {
    path: '/auth/login',
    name: 'UserLogin',
    component: DriverLogin,
    meta: {
      title: 'Login | Taxi1',
    }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
    meta: {
      title: '未授權訪問'
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 全域路由守衛
router.beforeEach(async (to, from, next) => {
  const driverToken = localStorage.getItem('driverToken');
  const adminToken = localStorage.getItem('adminToken');
  const driver = JSON.parse(localStorage.getItem('Driver'));
  const admin = JSON.parse(localStorage.getItem('Admin'));

  const isAdminRoute = to.path.startsWith('/admin');
  const isAuthRoute = to.path === '/auth/login';
  const isAdminLoginRoute = to.path === '/admin/login';

  // 1) 如果要驗證
  if (to.meta.requiresAuth) {
    if (isAdminRoute) {
      // 後台
      if (!adminToken) {
        if (to.path !== '/admin/login') {
          return next('/admin/login');
        } else {
          return next();
        }
      }
      if (admin && admin.role !== 'admin') {
        if (to.path !== '/admin/login') {
          return next('/admin/login');
        } else {
          return next();
        }
      }
    } else {
      // 前台
      if (!driverToken) {
        if (to.path !== '/auth/login') {
          return next('/auth/login');
        } else {
          return next();
        }
      }
      if (driver && driver.role !== 'user') {
        if (to.path !== '/') {
          return next('/');
        } else {
          return next();
        }
      }
    }
  }

  // 2) 如果使用者已登入
  if (driver || admin) {
    if ((isAuthRoute && driver) || (isAdminLoginRoute && admin)) {
      if (admin && to.path !== '/admin/home') {
        return next('/admin/home');
      }
      if (driver && to.path !== '/') {
        return next('/');
      }
    }
  } else {
    // 未登入的路由檢查
    if (isAuthRoute || isAdminLoginRoute) {
      return next();
    }
  }

  // 如果是前台路由，且有 driverToken，就重新 fetch driver info
  if (!isAdminRoute && driverToken) {
    try {
      await fetchDriverInfo(driverToken);  // 重新更新 localStorage 中的 Driver
    } catch (err) {
      console.error('Failed to refresh driver info:', err);
    }
  }

  //阻擋 /withdraw-funds，若 payment_method != 'Cash' 就導回 '/'
  if (!isAdminRoute && to.path === '/withdraw-funds') {
    if (driver && driver.withdraw_enabled !== true) {
      return next('/');
    }
  }

  // 只在 admin 角色時進行權限檢查
  if (isAdminRoute && admin && admin.role === 'admin') {
    // 檢查權限
    if (to.meta.permission) {
      const permissionStore = usePermissionStore();
      const userInfo = JSON.parse(localStorage.getItem('Admin'));

      // 如果還沒有權限資料，先獲取
      if (permissionStore.permissions.length === 0) {
        if (userInfo && userInfo.role_id) {
          await permissionStore.fetchPermissions(userInfo.role_id);
        } else {
            // 清空 localStorage 的 Admin 資訊
            localStorage.removeItem('Admin');
            // 導向登入頁
            next({ path: '/admin/login' });
            return;
        }
      }
      // 檢查是否有權限
      if (!permissionStore.hasPermission(to.meta.permission)) {
          // 清空 localStorage 的 Admin 資訊
          localStorage.removeItem('Admin');
          // 導向登入頁
          next({ path: '/admin/login' });
          return;
      }
    }
  }

  next();
});

export default router;
